import React from 'react'
import './vedio.css'
function Vedio() {
    return (
        <>
            <div className="video-body">
                    <div className="left">
                        <img src={`image/video.gif`} alt=""/>
                    </div>

                    <div className="right">
                        <h1>ڤیدیۆ</h1>
                    </div>
                </div>
        </>
    )
}

export default Vedio
